// extracted by mini-css-extract-plugin
export var activityContainer = "_ez-0";
export var typingIndicatorContainer = "_ez-1";
export var typingIndicatorDot = "_ez-2";
export var wave = "_ez-3";